<template>
	<div class="shd">
        <h3>浙江华统肉制品股份有限公司发货单</h3>
        <header>
            <p>客户：4号楼</p>
            <p>2026年3月27日</p>
        </header>

        <el-table
            algin='center'
            stripe
            size='mini'
            border
            :data="list">
            <el-table-column
                label="品名"
                prop="pm" >
            </el-table-column>

            <el-table-column
                label="单位"
                prop="dw">
            </el-table-column>

            <el-table-column
                label="等级"
                prop="dj">
            </el-table-column>

            <el-table-column
                label="规格"
                prop="gg">
            </el-table-column>
            
            <el-table-column
                label="数量"
                prop="sl">
            </el-table-column>
 
            <el-table-column
                label="重量"
                prop="zl">
            </el-table-column>
            
            <el-table-column
                label="单价"
                prop="dj">
            </el-table-column>

            <el-table-column
                label="金额"
                prop="je">
            </el-table-column>

            <el-table-column
                label="备注"
                prop="bz">
            </el-table-column>
        </el-table>
        
        <footer>
            <p>制单人：张三</p>
            <p>收货人：李四</p>
        </footer>

        <el-divider></el-divider>

        <header>

            <p>8号楼</p>
            <p>2026年3月27日</p>
        </header>

        <el-table
            algin='center'
            stripe
            size='mini'
            border
            :data="list">
            <el-table-column 
                label="品名" 
                prop="pm" >
            </el-table-column>

            <el-table-column 
                label="单位" 
                prop="dw">
            </el-table-column>

            <el-table-column 
                label="等级" 
                prop="dj">
            </el-table-column>

            <el-table-column 
                label="规格" 
                prop="gg">
            </el-table-column>

            <el-table-column 
                label="数量" 
                prop="sl">
            </el-table-column>

            <el-table-column 
                label="重量" 
                prop="zl">
            </el-table-column>
            
            <el-table-column 
                label="单价" 
                prop="dj">
            </el-table-column>

            <el-table-column 
                label="金额" 
                prop="je">
            </el-table-column>

            <el-table-column 
                label="备注" 
                prop="bz">
            </el-table-column>
        </el-table>
        
        <footer>
            <p>制单人：张三</p>
            <p>收货人：李四</p>
        </footer>

    </div>
</template>

<script>
    import shitang from "../config/option.js"
    import { url } from '../router/api';
	export default{
        data() {
            return {
                list:[
                    {
                        pm:"大五花",
                        dw:"无",
                        dj:"无",
                        gg:"无",
                        sl:"1",
                        zl:"2",
                        dj:"16.5",
                        je:"33",
                        bz:"无",
                    },
                    {
                        pm:"猪脊骨",
                        dw:"无",
                        dj:"无",
                        gg:"无",
                        sl:"1",
                        zl:"2",
                        dj:"16.5",
                        je:"33",
                        bz:"无",
                    },
                    {
                        pm:"猪蹄",
                        dw:"无",
                        dj:"无",
                        gg:"无",
                        sl:"1",
                        zl:"2",
                        dj:"16.5",
                        je:"33",
                        bz:"无",
                    },
                    {
                        pm:"合计",
                        je:'88',
                    },
                ]
            };
        },
        methods: {
           
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .shd {
        padding: 0 20px;
        h3 {
            text-align: center;
        }
        header {
            display: flex;
            justify-content: space-between;
        }
        footer {
            display: flex;
            justify-content: space-between;
        }
    }
</style>